import { render } from "./EditTransaction.vue?vue&type=template&id=5fb32f15"
import script from "./EditTransaction.vue?vue&type=script&lang=js"
export * from "./EditTransaction.vue?vue&type=script&lang=js"
script.render = render

export default script